"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var Toolbar = (function () {
    function Toolbar() {
    }
    return Toolbar;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], Toolbar.prototype, "style", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], Toolbar.prototype, "styleClass", void 0);
Toolbar = __decorate([
    core_1.Component({
        selector: 'p-toolbar',
        template: "\n        <div [ngClass]=\"'ui-toolbar ui-widget ui-widget-header ui-corner-all ui-helper-clearfix'\" [ngStyle]=\"style\" [class]=\"styleClass\">\n            <ng-content></ng-content>\n        </div>\n    "
    })
], Toolbar);
exports.Toolbar = Toolbar;
var ToolbarModule = (function () {
    function ToolbarModule() {
    }
    return ToolbarModule;
}());
ToolbarModule = __decorate([
    core_1.NgModule({
        imports: [common_1.CommonModule],
        exports: [Toolbar],
        declarations: [Toolbar]
    })
], ToolbarModule);
exports.ToolbarModule = ToolbarModule;
//# sourceMappingURL=toolbar.js.map


//////////////////
// WEBPACK FOOTER
// ./~/primeng/components/toolbar/toolbar.js
// module id = 1128
// module chunks = 8